import { CompanyLifecycle } from '@/gen/inventory/v1/company_lifecycle_pb'

import type { CompanyRow } from '@/pages/third-party-inventory/ag-grid-inventory/types'

import { CompanyLifecycleBadge } from '@/components/shared/company-lifecycle-badge/company-lifecycle-badge'

export const LifecycleCell = (params: { data?: CompanyRow | null }) => {
  const lifecycle = params.data?.lifecycle
  if (lifecycle === undefined || lifecycle === null) return null

  // Don't show badge if it's UNSPECIFIED
  if (lifecycle === CompanyLifecycle.UNSPECIFIED) return null

  return (
    <div className='flex size-full items-center'>
      <CompanyLifecycleBadge lifecycle={lifecycle} />
    </div>
  )
}
